import { useEffect, useRef } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'
import useGame from '../stores/useGame'

export function CubeSat(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/Cube_Sat.glb')
  const { actions } = useAnimations(animations, group)

  const phase = useGame((state) => state.phase)

  useEffect(() => {
    if (phase === 'zoomed') {
      actions.CubeSat_AnimatorAction.loop = false
      actions.CubeSat_AnimatorAction.clampWhenFinished = true
      actions.CubeSat_AnimatorAction.timeScale = 1
      actions.CubeSat_AnimatorAction.repetitions = 0
      actions.CubeSat_AnimatorAction.paused = false
      actions.CubeSat_AnimatorAction.play()
    }

    if (phase != 'zoomed') {
      actions.CubeSat_AnimatorAction.loop = false
      actions.CubeSat_AnimatorAction.clampWhenFinished = true
      actions.CubeSat_AnimatorAction.timeScale = -1
      actions.CubeSat_AnimatorAction.repetitions = 0
      actions.CubeSat_AnimatorAction.paused = false
      actions.CubeSat_AnimatorAction.play()
    }
  }, [phase, actions])

   return (
     <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group name="CubeSat_Animator">
          <mesh
            name="B_Brace"
            castShadow
            receiveShadow
            geometry={nodes.B_Brace.geometry}
            material={materials.Cube_Sat}
            position={[0.162, -0.001, -0.001]}
            rotation={[-0.001, -0.004, -0.001]}
          />
          <mesh
            name="B_Panel_1"
            castShadow
            receiveShadow
            geometry={nodes.B_Panel_1.geometry}
            material={materials.Cube_Sat}
            position={[0.025, -0.136, -0.002]}
            rotation={[-0.001, -0.004, -0.001]}
          />
          <mesh
            name="B_Panel_2"
            castShadow
            receiveShadow
            geometry={nodes.B_Panel_2.geometry}
            material={materials.Cube_Sat}
            position={[0.025, -0.136, -0.002]}
            rotation={[-3.141, 0.004, 3.14]}
          />
          <mesh
            name="B_Plate"
            castShadow
            receiveShadow
            geometry={nodes.B_Plate.geometry}
            material={materials.Cube_Sat}
            position={[0.028, -0.122, -0.001]}
            rotation={[-0.004, 0.001, -1.572]}
          />
          <mesh
            name="Front_Plate"
            castShadow
            receiveShadow
            geometry={nodes.Front_Plate.geometry}
            material={materials.Cube_Sat}
            position={[-0.472, 0.06, 0.008]}
            rotation={[-0.001, -0.004, -0.001]}
          />
          <mesh
            name="L_Solar_1"
            castShadow
            receiveShadow
            geometry={nodes.L_Solar_1.geometry}
            material={materials.Cube_Sat}
            position={[0.028, -0.001, 0.106]}
            rotation={[-0.001, -0.004, -0.001]}
          />
          <mesh
            name="L_Solar_2"
            castShadow
            receiveShadow
            geometry={nodes.L_Solar_2.geometry}
            material={materials.Cube_Sat}
            position={[0.022, 0.114, 0.234]}
            rotation={[-0.001, -0.004, -0.001]}
          />
          <mesh
            name="L_Solar_3"
            castShadow
            receiveShadow
            geometry={nodes.L_Solar_3.geometry}
            material={materials.Cube_Sat}
            position={[0.021, 0.116, 0.46]}
            rotation={[-0.001, -0.004, -0.001]}
          />
          <mesh
            name="M_Brace"
            castShadow
            receiveShadow
            geometry={nodes.M_Brace.geometry}
            material={materials.Cube_Sat}
            position={[-0.109, 0, -0.003]}
            rotation={[-0.001, -0.004, -0.001]}
          />
          <mesh
            name="Mid_Plate"
            castShadow
            receiveShadow
            geometry={nodes.Mid_Plate.geometry}
            material={materials.Cube_Sat}
            position={[-0.132, 0.001, -0.004]}
            rotation={[-0.001, -0.004, -0.001]}
          />
          <mesh
            name="Mid_Plate_2"
            castShadow
            receiveShadow
            geometry={nodes.Mid_Plate_2.geometry}
            material={materials.Cube_Sat}
            position={[0.191, 0, -0.001]}
            rotation={[-0.001, -0.004, -0.001]}
          />
          <mesh
            name="R_Solar_1"
            castShadow
            receiveShadow
            geometry={nodes.R_Solar_1.geometry}
            material={materials.Cube_Sat}
            position={[0.029, -0.002, -0.111]}
            rotation={[-0.001, -0.004, -0.001]}
          />
          <mesh
            name="R_Solar_2"
            castShadow
            receiveShadow
            geometry={nodes.R_Solar_2.geometry}
            material={materials.Cube_Sat}
            position={[0.024, 0.113, -0.24]}
            rotation={[-0.001, -0.004, -0.001]}
          />
          <mesh
            name="R_Solar_3"
            castShadow
            receiveShadow
            geometry={nodes.R_Solar_3.geometry}
            material={materials.Cube_Sat}
            position={[0.025, 0.115, -0.466]}
            rotation={[-0.001, -0.004, -0.001]}
          />
          <mesh
            name="T_Panel"
            castShadow
            receiveShadow
            geometry={nodes.T_Panel.geometry}
            material={materials.Cube_Sat}
            position={[0.026, 0.136, -0.003]}
            rotation={[-0.001, -0.004, -0.001]}
          />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/Cube_Sat.glb')